import { takeLatest, select, call, put } from "redux-saga/effects";
import axios from "axios";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";
import { requestDefaultJson } from './helpers'
import { Creators as actionFreeGates } from '../ducks/freeGates'

const setLoadFromAPi = (orders, token) => {
	return requestDefaultJson( {
		method: "POST",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + "/carga/montarcarga/", 
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CARGA"),
			"Authorization": token,
		},
		data: {
			idPedidos: orders.map(value => value.id)
		},
	});
}

const getLoadDetailsFromAPi = (loadId, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/carga/detalhe/" + loadId, {
			method: "GET",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CARGA"),
				"Content-Type": "application/json",
				"Authorization": token,
			},
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});

};

const getLoadListFromApi = ( {type, id }, token ) => {
	return requestDefaultJson( {
		method: "GET",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + `/carga/listar/${type}/${id}`, 
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CARGA"),
			"Authorization": token,
		}
	});
};

const addLoadOrderFromApi = (loadId, orderlist, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/carga/adicionarpedido", {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CARGA"),
				"Content-Type": "application/json",
				"Authorization": token,
		},
			data: {
				idCarga: loadId,
				idPedidos: orderlist
			}
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});

};

const deleteLoadOrderFromApi = (loadId, orderlist, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/carga/removerpedido", {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CARGA"),
				"Content-Type": "application/json",
				"Authorization": token,
		},
			data: {
				idCarga: loadId,
				idPedidos: orderlist
			}
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});

};

const deleteLoadFromApi = (loadId, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/carga/apagar/" + loadId, {
			method: "DELETE",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CARGA"),
				"Content-Type": "application/json",
				"Authorization": token,
		},
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});

};

//generators
function* getLoad(payload) {

	try {
		yield put(actionFreeGates.cleanGates());

		yield put({ type: "LOAD_DETAILS_LOADING" });

		const { token } = yield select(state => state.authentication);

		const data = yield call(getLoadDetailsFromAPi, payload.loadId, token);

		yield put({ type: "LOAD_DETAILS", payload: data });

	} catch (error) {
		if (error.response && error.response.data && error.response.data.status === 404) {
			yield put({ type: "LOAD_DELETE", payload: error.response.data });
			
			yield put({ type: "LOAD_ID_CLEAN", payload: error.response.data });
		}
		
		yield put({ type: "LOAD_DETAILS_ERROR", payload: error });

		log.info(error);
	}

}

//generators
function* setLoad({ payload }) {

	try {
		const { token } = yield select(state => state.authentication);
		yield put({ type: "SET_LOAD_LOADING" });

		const data = yield call(setLoadFromAPi, payload, token);

		if (data.carga) {
			yield put({ type: "SET_LOAD_SUCCESS", payload: data.carga });
		} else {
			yield put({ type: "SET_LOAD_FAIL", payload: data.message });
		}

	} catch (error) {
		yield put({ type: "SET_LOAD_FAIL", payload: error });
		log.info(error);
	}

}

function* addOrderLoad(payload) {

	try {
		const { token } = yield select(state => state.authentication);

		const data = yield call(addLoadOrderFromApi, payload.loadId, payload.orderlist, token);

		yield put({ type: "LOAD_ADD_ORDER_FROM_MODAL", payload: data.message });

		yield put({ type: "LOAD_ADD_ORDER_FROM_MODAL", payload: null });

		yield put({ type: "GET_LOAD_DETAILS", loadId: payload.loadId });
		
		yield put({ type: "SET_LOAD_ADD_SUCCESS", payload:{ success: true, type: "save" }});

	} catch (error) {
		
		yield put({ type: "SET_LOAD_ADD_ERROR", payload:{ error: true, data: error.response.data }});

		log.info(error);
	}

}

function* removeOrderLoad({payload}) {

	try {
		const { token } = yield select(state => state.authentication);

		const data = yield call(deleteLoadOrderFromApi, payload.loadId, payload.orderlist, token);

		yield put({ type: "LOAD_DELETE_ORDER", payload: data.message });

		yield put({ type: "LOAD_CLEAN_ORDERS" });

		yield put({ type: "GET_LOAD_DETAILS", loadId: payload.loadId });

		yield put({ type: "SET_LOAD_ADD_SUCCESS", payload:{ success: true, type: "delete" }});

	} catch (error) {

		yield put({ type: "SET_LOAD_ADD_ERROR", payload:{ error: true, data: error.response.data }});

		log.info(error);
	}

}



function* deleteLoad(payload) {

	try {
		const { token } = yield select(state => state.authentication);

		const data = yield call(deleteLoadFromApi, payload.loadId, token);

		yield put({ type: "LOAD_DELETE", payload: data });
		
		yield put({ type: "LOAD_ID_CLEAN", payload: data });
		
	} catch (error) {
	
		log.info(error);
	}

}

//generators
function* getLoadList(payload) {

	try {
		const { token } = yield select(state => state.authentication);

		const data = yield call( getLoadListFromApi, payload.profile, token);

		yield put({ type: "GET_LOAD_LIST_SUCCESS", payload: data });

	} catch (error) {
		log.info(error);
	}

}

// //Generator function
export function* getLoadWatcher() {
	yield takeLatest("SET_LOAD", setLoad);

	yield takeLatest("GET_LOAD_DETAILS", getLoad);

	yield takeLatest("GET_LOAD_LIST", getLoadList);

	yield takeLatest("ADD_ORDER_LOAD", addOrderLoad);

	yield takeLatest("DELETE_ORDER_LOAD", removeOrderLoad);

	yield takeLatest("DELETE_LOAD", deleteLoad);
}
